import React from 'react';
import { Button } from 'antd';
import { DeleteOutlined, DownOutlined, UpOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { TGDDesign } from '../../../../models/courses/graphicDesign';
import { TGDReorder } from '../../core/document';

interface LayersPanelProps {
  design: TGDDesign; selectedId: string | null; onSelect: (id: string) => void;
  onMove: (id: string, move: TGDReorder) => void; onRemove: (id: string) => void;
}

const LayersPanel: React.FC<LayersPanelProps> = ({ design, selectedId,
  onSelect, onMove, onRemove }) => {
  const { t } = useTranslation();
  return <section className="gd-panel">
    <h3>{t('graphicDesignLesson.editor.layers')}</h3>
    {[...design.components].sort((a, b) => (b.layer ?? 0) - (a.layer ?? 0)).map(c =>
      <div className="gd-layer-row" key={c.id}>
        <Button type={selectedId === c.id ? 'primary' : 'text'}
          className="gd-layer-name" onClick={() => onSelect(c.id)}>
          {c.type === 'text' ? c.text?.slice(0, 20) : c.type === 'pictogram' ? c.icon
            : t(`graphicDesignLesson.editor.shape.${c.sides ?? 3}`)}
        </Button>
        <Button icon={<UpOutlined />} aria-label={t('graphicDesignLesson.editor.forward')}
          onClick={() => onMove(c.id, 'forward')} />
        <Button icon={<DownOutlined />} aria-label={t('graphicDesignLesson.editor.backward')}
          onClick={() => onMove(c.id, 'backward')} />
        <Button danger icon={<DeleteOutlined />} aria-label={t('graphicDesignLesson.editor.delete')}
          onClick={() => onRemove(c.id)} />
      </div>)}
  </section>;
};

export default LayersPanel;
